import AvatarContent from '../shared/components/avatar/avatar-content';
import AvatarWidget from '../shared/components/avatar/avatar-widget';
import HuitabAnchor from '../shared/components/common/huitab-anchor';
import HuitabHeader from '../shared/components/common/huitab-header';
import HuitabMicroapp from '../shared/components/common/huitab-microapp';
import HuitabToast from '../shared/components/common/huitab-toast';
import IframeBase from '../shared/components/micro-apps/iframe-base';
import ActualitesMicroApp from '../shared/components/micro-apps/micro-app-actualites';
import ActualitesWidgetMicroApp from '../shared/components/micro-apps/micro-app-actualites-widget';
import AideEtContactMicroApp from '../shared/components/micro-apps/micro-app-aide-et-contact';
import MicroApp from '../shared/components/micro-apps/micro-app-base';
import CartographieReseauMicroApp from '../shared/components/micro-apps/micro-app-cartographie-reseau';
import CompteursMicroApp from '../shared/components/micro-apps/micro-app-compteurs';
import FaqDocumentationMicroApp from '../shared/components/micro-apps/micro-app-faq-documentation';
import GestionCompteMicroApp from '../shared/components/micro-apps/micro-app-gestion-compte';
import GestionInterlocuteursEnMasseMicroApp from '../shared/components/micro-apps/micro-app-gestion-interlocuteurs-en-masse.js';
import InterlocuteursCoupuresMicroApp from '../shared/components/micro-apps/micro-app-interlocuteurs-coupures';
import PortailDevMicroApp from '../shared/components/micro-apps/micro-app-portail-dev';
import RechercheCompteursMicroApp from '../shared/components/micro-apps/micro-app-recherche-compteurs';
import WidgetAideEtContactMicroApp from '../shared/components/micro-apps/micro-app-widget-aide-et-contact';
import WidgetCoupuresMicroApp from '../shared/components/micro-apps/micro-app-widget-coupures';
import ModalCgu from '../shared/components/modals/modal-cgu';
import ModalEtatServices from '../shared/components/modals/modal-etat-services';
import ModalExternalLink from '../shared/components/modals/modal-extenal-link';
import ModalLogout from '../shared/components/modals/modal-logout';
import ModalPopinNoCarto from '../shared/components/modals/modal-popin-no-carto';
import ModalSearchExportSuccess from '../shared/components/modals/modal-search-export-success';
import WidgetMesures from '../shared/components/widgets/widget-mesures';
import WidgetTravaux from '../shared/components/widgets/widget-travaux';

/**
 * Définition des custom elements
 */
// Common
customElements.define('huitab-anchor', HuitabAnchor, { extends: 'a' });
customElements.define('huitab-header', HuitabHeader, { extends: 'header' });
customElements.define('huitab-microapp', HuitabMicroapp);
customElements.define('huitab-toast', HuitabToast);

// Iframe et microapps
customElements.define('micro-app', MicroApp, { extends: 'div' });
customElements.define('micro-app-gestion-compte', GestionCompteMicroApp, { extends: 'div' });
customElements.define('micro-app-widget-coupures', WidgetCoupuresMicroApp, { extends: 'div' });
customElements.define('micro-app-compteurs', CompteursMicroApp, { extends: 'div' });
customElements.define('micro-app-recherche-compteurs', RechercheCompteursMicroApp, { extends: 'div' });
customElements.define('micro-app-portail-dev', PortailDevMicroApp, { extends: 'div' });
customElements.define('micro-app-iframe-base', IframeBase, { extends: 'div' });
customElements.define('micro-app-faq-documentation', FaqDocumentationMicroApp, { extends: 'div' });
customElements.define('micro-app-actualites-widget', ActualitesWidgetMicroApp, { extends: 'div' });
customElements.define('micro-app-actualites', ActualitesMicroApp, { extends: 'div' });
customElements.define('micro-app-cartographie-reseau', CartographieReseauMicroApp, { extends: 'div' });
customElements.define('micro-app-widget-aide-et-contact', WidgetAideEtContactMicroApp, { extends: 'div' });
customElements.define('micro-app-interlocuteurs-coupures', InterlocuteursCoupuresMicroApp, { extends: 'div' });
customElements.define('micro-app-gestion-interlocuteurs-en-masse', GestionInterlocuteursEnMasseMicroApp, {
  extends: 'div',
});
customElements.define('micro-app-aide-et-contact', AideEtContactMicroApp, { extends: 'div' });

// Modals
customElements.define('modal-enedis-cgu', ModalCgu, { extends: 'div' });
customElements.define('modal-logout', ModalLogout, { extends: 'div' });
customElements.define('modal-external-link', ModalExternalLink, { extends: 'div' });
customElements.define('modal-popin-no-carto', ModalPopinNoCarto, { extends: 'div' });
export const modalSearchExportSuccess = new ModalSearchExportSuccess();
export const modalEtatServices = new ModalEtatServices();

// Widgets
customElements.define('widget-travaux', WidgetTravaux, { extends: 'div' });
customElements.define('widget-mesures', WidgetMesures, { extends: 'a' });

// Avatar
customElements.define('avatar-content', AvatarContent, { extends: 'div' });
customElements.define('avatar-wrapper', AvatarWidget, { extends: 'div' });
